import ApiClient from 'common/ApiClient'

export default {
  methods: {
    async retrieveChildren(index, catid) {
      var api = new ApiClient()
      const response = await api.get(
        `${gon.url_for.navigation_index_search.replace(':id', index)}?catid=${catid}`
      )
      return response.data || []
    }
  }
}
